export default __webpack_public_path__ + "static/media/illustration-without-shadows.562ffd62.svg";